export default "__VITE_ASSET__BwkqXVXb__"